export const FIND_CHAT_CONVERSATION_FAILURE = 'FIND_CHAT_CONVERSATION_FAILURE';

export const findChatConversationFailure = error => ({
    type: FIND_CHAT_CONVERSATION_FAILURE,
    payload: error,
    error: true,
});
